var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dashboard-page',{attrs:{"title":"Novo requerimento"}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"card-wrapper"},[_c('issues-form-validation')],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }